import { render, staticRenderFns } from "./unlinkedCard.vue?vue&type=template&id=603886e0&scoped=true"
import script from "./unlinkedCard.vue?vue&type=script&lang=js"
export * from "./unlinkedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603886e0",
  null
  
)

export default component.exports